// extracted by mini-css-extract-plugin
export default {"videoPlayer":"VideoTag_videoPlayer__nV5Iz"};